
import { Component, Vue } from 'vue-property-decorator'
import { gtm } from "@/util/GTMService";

@Component({})
export default class RedirectToKionButton extends Vue {
	redirectToKion() {
      gtm.pushEvent({
        event: 'landing_button_click',
        event_name: 'landing_button_click',
        button_id: 'continue',
        button_text: 'Продолжить',
      })

      window.location.href = "https://kion.ru"
	}
}
